import axios from "axios";
import { getToken } from '~/redux/user/tokens';

const APIUrl = window.settings.apiBaseUrl + "/subscription";

/**
 * This function is use for create customer on the payment gateway with their information
 * @param {*} phoneNumber : Phone number at time of checkout.
 */
export async function createCustomer(phoneNumber) {
  return await (
    getToken()
      .then(token => axios({
        url: `${APIUrl}/customer`,
        method: "POST",
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
          'x-api-key': window.settings.baseAPIKey
        },
        data: {
          mobile_number: phoneNumber
        }
      })
        .then(res => {
          return res;
        })
        .catch(error => {
          return error.response;
        })
      )
  )
}

/**
 *  This function create a new order with given customer details.
 * @param {*} userEmail : Customer Email ID, which is  given at time of sign up.
 * @param {*} userName : Customer Username.
 * @param {*} customer_id : Created Customer ID at gateway.
 * @param {*} planId : Customer chosen plan ID.
 * @param {*} paymentCurrencyCode : plan currency.
 * @param {*} phoneNumber : customer phone number at time of checkout.
 */
export async function createOrderAndCustomer(
  userEmail,
  userName,
  planId,
  planIdentifier,
  countryCode,
  paymentCurrencyCode,
  phoneNumber,
  appliedOfferCode
) {
  return await (
    getToken()
      .then(token => axios({
        url: `${APIUrl}/subscribe`, // Now there is only one API for create customer and order creation.
        method: "POST",
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
          'x-api-key': window.settings.baseAPIKey
        },
        data: {
          currency: paymentCurrencyCode,
          billing_email: userEmail,
          billing_name: userName,
          mobile_number: phoneNumber,
          billing_country: "India",
          "options.create_mandate": "OPTIONAL",
          udf4: planIdentifier,
          udf7: "web_browser",
          udf8: planId,
          udf9: btoa(window.location.origin + window.location.pathname),
          udf10: appliedOfferCode || false,
          "options.get_client_auth_token": true,
          "metadata.PAYPAL:landing_page":"Billing", // For paypal auto fill
          "metadata.PAYPAL:phone_number": phoneNumber, // For paypal auto fill
          "metadata.PAYPAL:first_name": userName, // For paypal auto fill
          "metadata.PAYPAL:last_name": "", // For paypal auto fill
          "metadata.PAYPAL:email_address": userEmail, // For paypal auto fill
          "metadata.PAYPAL:country_code": countryCode // For paypal auto fill
        }
      })
        .then(res => {
          return res;
        })
        .catch(error => {
          return error.response;
        })
      )
  )
}

/**
 * This function is use for getting payment link in netBanking, paypal and wallet
 * @param {*} paymentMethodType : NB
 * @param {*} paymentMethod : NB_SBI
 * @param {*} redirectFlag : Its true by default.
 * @param {*} format: JSON type
 */
export async function getPaymentLink(
  paymentMethodType,
  paymentMethod,
  redirectFlag,
  format
) {
  return await (
    getToken()
      .then(token => axios({
        url: `${APIUrl}/payment`, // --4 API  Call
        method: "POST",
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
          'x-api-key': window.settings.baseAPIKey
        },
        data: {
          payment_method_type: paymentMethodType,
          payment_method: paymentMethod,
          redirect_after_payment: redirectFlag,
          format: format
        }
      })
        .then(res => {
          return res;
        })
        .catch(error => {
          return error.response;
        })
      )
  )
}

/**
 * This is use getting payment link, when user paying with debit/ credit card.
 * @param {*} postDataForPayment : JSON parameters.
 */
export async function getCardsPaymentLink(postDataForPayment) {
  return await (
    getToken()
      .then(token => axios({
        url: `${APIUrl}/payment`,
        method: "POST",
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
          'x-api-key': window.settings.baseAPIKey
        },
        data: postDataForPayment
      })
        .then(res => {
          return res;
        })
        .catch(error => {
          return error.response;
        })
      )
  )
}

/**
 * This is use getting payment link, when user paying with UPI.
 * @param {*} paymentMethodType
 * @param {*} paymentMethod
 * @param {*} txnType
 * @param {*} upiVpa
 * @param {*} redirectFlag
 * @param {*} format
 */
export async function getUPIPaymentLink(
  paymentMethodType,
  paymentMethod,
  txnType,
  upiVpa,
  redirectFlag,
  format
) {
  return await (
    getToken()
      .then(token => axios({
        url: `${APIUrl}/payment`,
        method: "POST",
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
          'x-api-key': window.settings.baseAPIKey
        },
        data: {
          payment_method_type: paymentMethodType,
          payment_method: paymentMethod,
          txn_type: txnType,
          upi_vpa: upiVpa,
          redirect_after_payment: redirectFlag,
          format: format
        }
      })
        .then(res => {
          return res;
        })
        .catch(error => {
          return error.response;
        })
      )
  )
}

/**
 * For getting list of customer saved card.
 * @param {*} customerId : Customer ID created at the time of payment.
 */
export async function getCardsList() {
  return await (
    getToken()
      .then(token => axios({
        url: `${APIUrl}/card`,
        method: "GET",
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
          'x-api-key': window.settings.baseAPIKey
        }
      })
        .then(res => {
          return res;
        })
        .catch(error => {
          return error.response;
        })
      )
  )
}

/**
 * Function use for removing customer saved card.
 * @param {*} savedcard_token: saved card token number.
 */
export async function deleteCard(savedcard_token) {
  return await (
    getToken()
      .then(token => axios({
        url: `${APIUrl}/card`,
        method: "POST",
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
          'x-api-key': window.settings.baseAPIKey
        },
        data: {
          card_token: savedcard_token
        }
      })
        .then(res => {
          return res;
        })
        .catch(error => {
          return error.response;
        })
      )
  )
}
